import React from "react";
import { PaymentMethod } from "../../components/Payment/PaymentMethod";

export function CoursePurchasePage(props: {}) {
  return <PaymentMethod />;
}
